import jwt_decode from "jwt-decode";
import { logout } from "../auth/auth";
import { PricingType } from "../../models/features/Integration/DmsSetup";
import { Part } from "../../models/features/Part/Parts";
import { DmsPart } from "../../models/features/ShoppingPortal/DmsPart";
import { GridColDef, GridColumnVisibilityModel } from "@mui/x-data-grid";
import { PortalSettingRule } from "../../models/features/ShopifySetting/Portal Setting Rules/PortalSettingRules";

export function isTokenValid(token: string, dispatch: any) {
  var decoder = jwt_decode(token) as any;
  var expiry = new Date(1000 * decoder.exp);
  var now = new Date(Date.now());

  if (expiry <= now) {
    dispatch(logout());
    return false;
  } else {
    return true;
  }
}

export const getPartPrice = (
  item: DmsPart,
  pricing: PricingType | undefined
) => {
  switch (pricing) {
    case PricingType.Price:
      return item.price;
    case PricingType.RetailPrice:
      if (pricing == PricingType.RetailPrice && item.suggestedRetailPrice > 0)
        return item.suggestedRetailPrice;
      return item.price;
    default:
      return item.price;
  }
};

export function getFullName(
  firstName?: string,
  middleName?: string,
  lastName?: string
) {
  let fullName = firstName;
  if (middleName) {
    fullName += " " + middleName;
  }
  if (lastName) {
    fullName += " " + lastName;
  }
  return fullName;
}

export function GetAppGridColumns(
  columns: GridColDef[],
  visibility?: GridColumnVisibilityModel
) {
  return columns.map((column) => ({
    ...column,
    hide: visibility ? !visibility[column.field] : false,
  }));
}

export const handleGetPartPrice = (
  part: DmsPart,
  rules: PortalSettingRule[] | undefined
) => {
  let price = part.price.toFixed(2);
  if (!rules || rules.length === 0) {
    return price;
  }
  let priceText = null;
  const shouldHidePrice = rules.some((rule) => {
    if (rule.hidePrice) {
      if (rule.applyOnAllParts) {
        priceText = rule.priceReplacementText || "Call for pricing";
        return true;
      }
      if (
        rule.manufacturers?.includes(part.mfrCode) ||
        rule.partNumbers?.includes(part.inventoryPartId)
      ) {
        priceText = rule.priceReplacementText || "Call for pricing";
        return true;
      }
    }
    return false;
  });

  return shouldHidePrice ? priceText : price;
};

export const handleCartButtonAction = (
  part: DmsPart,
  rules: PortalSettingRule[] | undefined
) => {
  if (!rules || rules.length === 0) {
    return { hideButton: false, tooltipText: "" };
  }

  let tooltipText = "Call for details";
  const hideButton = rules.some((rule: PortalSettingRule) => {
    if (rule.hideCartButton) {
      if (rule.applyOnAllParts) {
        tooltipText = rule.cartReplacementText || tooltipText;
        return true;
      }
      if (
        rule.manufacturers?.includes(part.mfrCode) ||
        rule.partNumbers?.includes(part.inventoryPartId)
      ) {
        tooltipText = rule.cartReplacementText || tooltipText;
        return true;
      }
    }
    return false;
  });

  return { hideButton, tooltipText };
};

export function capitalizeFirstLetter(str: string | undefined) {
  if (!str) return ""; // Check for empty or undefined string
  return str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}
